import { render, staticRenderFns } from "./bi-item-list.vue?vue&type=template&id=2df5706d&"
import script from "./bi-item-list.vue?vue&type=script&lang=ts&"
export * from "./bi-item-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports